import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { timeFormat } from '../../util/DateUtil';
import 'react-toastify/dist/ReactToastify.css';
import { errorMessage } from '../../util/ConfirmAlertUtil';
import { findAll } from './Aula/api-cronograma-aula';
import { splitUtil } from '../../util/StringUtil';


const useStyles = makeStyles({

    table: {
        minWidth: 650,
    },
    novoRegistro: {
        marginBottom: '30px'
    },
    cursorLink: {
        cursor: 'pointer'
    },
    mediaPrintElement: {
        '@media print': {
            display: 'none'
        }
    },
    textTableHeader: {
        fontSize: 10,
        fontWeight: 'bold',
        lineHeight: '0.8',
        textAlign: 'center'
    },
    textTableBody: {
        fontSize: 10,
        lineHeight: '0.8',
        textAlign: 'center'
    }
});


export default function CronogramaTableV2({ cronogramas }) {
    const classes = useStyles();

    const [listCronogramaAula, setListCronogramaAula] = useState([]);

    useEffect(() => {
        findAll().then((data) => {
            if (data) {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    setListCronogramaAula(data);
                }
            }
        })
    }, []);


    return (
        <Table size="small" aria-label="a dense table" >
            <TableHead>
                <TableRow>
                    <TableCell>
                        <p className={classes.textTableHeader}>
                            Horário
                        </p>
                    </TableCell>
                    <TableCell>
                        <p className={classes.textTableHeader}>
                            Segunda
                        </p>
                    </TableCell>
                    <TableCell>
                        <p className={classes.textTableHeader}>
                            Terça
                        </p>
                    </TableCell>
                    <TableCell>
                        <p className={classes.textTableHeader}>
                            Quarta
                        </p>
                    </TableCell>
                    <TableCell>
                        <p className={classes.textTableHeader}>
                            Quinta
                        </p>
                    </TableCell>
                    <TableCell>
                        <p className={classes.textTableHeader}>
                            Sexta
                        </p>
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {listCronogramaAula.map((ca) => {
                    const confirmExists = cronogramas.filter((cronogramaTotal) =>
                        cronogramaTotal.cronogramaAula.codigo === ca.codigo).length > 0;
                    if (confirmExists) {
                        return (
                            <>
                                <TableRow key={ca.codigo} >
                                    <TableCell style={{ maxWidth: 20 }}>
                                        <p className={classes.textTableHeader}>
                                            {timeFormat(ca.horarioInicio)} -{" "}
                                            {timeFormat(ca.horarioFim)}
                                        </p>
                                    </TableCell>
                                    {cronogramas.filter((cronogramaTotal) =>
                                        cronogramaTotal.cronogramaAula.codigo === ca.codigo).map((c) =>
                                        (
                                            <TableCell >
                                                <p className={classes.textTableHeader}>
                                                    {c.tdp && c.tdp.disciplina ? c.tdp.disciplina.descricao.length > 20 ? c.tdp.disciplina.descricao.substring(0, 25) : c.tdp.disciplina.descricao : "--"}
                                                </p>
                                                <p className={classes.textTableBody}>
                                                    {c.tdp && c.tdp.usuario ? splitUtil(c.tdp.usuario.nome, " ", 2) + " - " : ""} {c.local ? c.local.descricao : ""}
                                                </p>
                                            </TableCell>
                                        ))}
                                </TableRow>
                            </>
                        )
                    } else {
                        return <></>
                    }

                }
                )}

            </TableBody>
        </Table>
    );
}